import { ExamLocationActivityLogList } from '@exam-center/exam-location-activity-log-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ActivityLogPage() {
  return (
    <PermissionGuard
      requiredPermission={[APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.AUDIT_LOG.VIEW]}
    >
      <PaperSection title='Activity Log'>
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            p: theme.spacing(6),
            gap: theme.spacing(6),
            height: '100%',
          })}
        >
          <ExamLocationActivityLogList />
        </Flex>
      </PaperSection>
    </PermissionGuard>
  );
}
